import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'DEMA',
  version: 1,
  label: 'Double Exponential Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 32,
  inputs: [period('timeperiod', 30)],
  outputs: [line('dema', 'DEMA', COLOR.blue)],
  talib: { functions: ['DEMA'], expr: 'DEMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 2 * (timeperiod - 1),
}
export default def
